import { useState, useMemo, useEffect, useRef } from 'react';
import '../../assets/css/StudentDashboard.css'

import { SuccessfulPopup } from '../../Component/Modals/SuccessfulPopup';
import Table from '../../Component/Table';
import edit from '../../assets/icons/editnew.svg';
import { CourseShortDetails } from './CourseShortDetails.js';
import { useNavigate } from 'react-router-dom';
import { getData, patchData, Postdata, PostdataWithJson, updateData } from '../../API/GlobalApi.js';
import { AddCourse } from '../../Component/Modals/AddCourse.js';
import { useTableFade } from '../../Utils/tableFadeHooks.js';
import AdvanceTable from '../../Utils/AdvanceTables.js';
import SpinnerLoader from '../../Utils/Spinner.js';
import TableLoaderOverlay from '../../Utils/tableFadingLoader.js';
import SearchingBar from '../../Utils/Searching.js';
import TableSkeleton from '../../Utils/TableSkeleton.js';

export const CourseDashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpendept, setIsModalOpendept] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [dnparentdata, setdnparentdata] = useState([]);
  const [classPage, setClassPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [classData, setClassData] = useState([]);
  const [filterCourseData, setfilterCourseData] = useState([])
  const [dnparentdata2, setdnparentdata2] = useState([]);
  const [selectedOrgDetails, setSelectedOrgDetails] = useState([]);
  const [departmentdetails, setdepartmentdetails] = useState(null);
  const [parentorgid, setparentorgid] = useState(null);
  const [parentorgidsub, setparentorgidsub] = useState(null);
  const [Updatebtn, setUpdatebtn] = useState(false);
  const pageSize = 10;
  const [status, setStatus] = useState(false);
  const [masterdata, setmasterdata] = useState([]);
  const pageCounts = Math.ceil(totalCount / pageSize);

  const emptySubject = {
    name: "",
    semester: "",
    type: "",
  };
  const [orgform, setorgform] = useState({
    name: "",
    level: "",
    mode: "",
    mode_count: null,
    duration: null,
    organization_id: null,
    status: false,
    alias: "",
    subjects: [emptySubject],
    course_type: "regular",

  })
  const [deptform, setdeptform] = useState({
    id: null,
    name: "",
    course_code: "",
    semester_fee: "",
    provisional_fee: "",
    intech_capacity: null
  })
  const [searchQuery, setSearchQuery] = useState('')
  const navigate = useNavigate();

  const isRequired = (val) => {
    if (typeof val === 'string') {
      return val.trim() !== '';
    }
    return val !== null && val !== undefined && val !== '';
  };

  const [duplicateSubjects, setDuplicateSubjects] = useState([]);

  const getSafeSubjects = (subjects) =>
    Array.isArray(subjects) ? subjects : [emptySubject];

  // subjects state can be an array of strings (loaded via handleEdit from a
  // comma-separated string the backend returns) OR an array of {name, ...} objects
  // (built by handleSubmit / addSubjectRow). Read whichever shape is present.
  const subjectName = (sub) => {
    if (typeof sub === 'string') return sub.trim();
    return (sub?.name || '').trim();
  };

  const handleSubjectChange = (index, field, value) => {
    setorgform(prev => {
      const safeSubjects = getSafeSubjects(prev.subjects);
      const updated = [...safeSubjects];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      const normalizedNames = updated.map(sub =>
        sub.name?.trim().toLowerCase()
      );

      const duplicates = normalizedNames.reduce((acc, name, i) => {
        if (!name) return acc;
        if (normalizedNames.indexOf(name) !== i) acc.push(i);
        return acc;
      }, []);

      setDuplicateSubjects(duplicates);

      return { ...prev, subjects: updated };
    });
  };


  const addSubjectRow = () => {
    setorgform(prev => {
      const safeSubjects = getSafeSubjects(prev.subjects);

      return {
        ...prev,
        subjects: [...safeSubjects, emptySubject],
      };
    });
  };

  const removeSubjectRow = (index) => {
    setorgform(prev => {
      const safeSubjects = getSafeSubjects(prev.subjects);

      const updated = safeSubjects.filter((_, i) => i !== index);

      const normalizedNames = updated.map(sub =>
        sub.name?.trim().toLowerCase()
      );

      const duplicates = normalizedNames.reduce((acc, name, i) => {
        if (!name) return acc;
        if (normalizedNames.indexOf(name) !== i) acc.push(i);
        return acc;
      }, []);

      setDuplicateSubjects(duplicates);

      return {
        ...prev,
        subjects: updated.length ? updated : [emptySubject],
      };
    });
  };






  const [isCourseSearching, setIsCourseSearching] = useState(false);
  const [filteredCourseData, setFilteredCourseData] = useState([]);



  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const displayToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true)
    setTimeout(() => setShowToast(false), 3000);
  };
  const getmasterdata = async () => {
    const url = "academics/courses/get-master-data/";
    const response = await getData(url);
    if (response) {
      setmasterdata(response);

    }
  }
  const skipSpinnerRef = useRef(false);



  const [isSearching, setIsSearching] = useState(false); // search has value
  const [isSearchLoading, setSearchLoading] = useState(false);
  const [isSearchPending, setIsSearchPending] = useState(false);
  const showSpinner = isSearchPending || isSearchLoading;
  const [filterQueryString, setFilterQueryString] = useState('');
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const { tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();
  const [searchValue, setSearchValue] = useState("");

  const getorgdata = async (page = 0, filters = filterQueryString) => {
    // const url = `academics/courses/?page=${page + 1}`;

    const pageNumber = page + 1;
    const queryParams = new URLSearchParams({
      ...filters,
      page: pageNumber,
    });
    queryParams.set("page", pageNumber);

    const url = `academics/courses/?${queryParams.toString()}`;

    // ✅ Only show spinner if skipSpinnerRef is false
    if (skipSpinnerRef.current) {
      skipSpinnerRef.current = false;
    } else {
      if (isInitialLoad) setIsLoading(true);
      else setSearchLoading(true);
    }

    try {

      const response = await getData(url);
      if (response) {
        const results = response.results;
        let selectedOrg = results[0];
        // if (updatedRowId) {
        //   const updatedRow = results.find(item => item.id === updatedRowId);
        //   if (updatedRow) selectedOrg = updatedRow;
        // }

        setClassData(results);
        setFilteredCourseData(results)
        setTotalCount(response.count || 0);
        setdnparentdata(results);
        setSelectedOrgDetails(selectedOrg);
        // ✅ Call only if id exists
        if (selectedOrg?.id) {
          getdeptdata(selectedOrg.id);
        }
      }
    } catch (error) {

    } finally {
      if (!skipSpinnerRef.current) {
        if (isInitialLoad) {
          setIsLoading(false);
          setIsInitialLoad(false);
        } else {
          setSearchLoading(false);
        }
      }

    }

  };

  // useEffect(() => {
  //   getorgdata(classPage);
  // }, [classPage]);

  const currentPageRef = useRef(classPage);


  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (isSearching && refreshKey === 0) return;
    currentPageRef.current = classPage;

    const fetchData = async () => {
      await getorgdata(currentPageRef.current, filterQueryString);
      stopTableLoading(); // hide overlay
    };

    fetchData();
    // getItems(currentPageRef).finally(() => stopTableLoading())
  }, [classPage, filterQueryString, refreshKey]);


  const handleClassPageChange = ({ selected }) => {
    triggerTableLoading();
    setClassPage(selected);
    // getorgdata(selected);
  };

  const getorgdata2 = async () => {
    const url = "administration/organizations/";
    const response = await getData(url);
    if (response) {
      setdnparentdata2(response);

    }

  }
  const getdeptdata = async (courseId) => {
    if (!courseId) return; // ✅ HARD STOP

    setparentorgid(courseId);
    const url = `academics/courses/${courseId}/specializations/`;
    const response = await getData(url);

    if (response) {
      setdepartmentdetails(response.results);
    }
  };


  useEffect(() => {
    if (selectedOrgDetails?.id) {
      getdeptdata(selectedOrgDetails.id);
    }
  }, [selectedOrgDetails?.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'name') {
      if (/^\d/.test(value)) return;
      const validName = value.replace(/[^a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>-]/g, ''); // Allow letters, numbers, spaces, and special characters
      setorgform(prev => ({ ...prev, [name]: validName }));

    } else if (name === 'duration' || name === 'mode_count') {
      const validNumber = value.replace(/\D/g, '');
      setorgform(prev => ({ ...prev, [name]: validNumber }));
    } else if (name === 'alias') {
      if (/^\d/.test(value)) return; // Prevent starting with digit
      const validName = value.replace(/[^a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>-]/g, '');
      setorgform(prev => ({ ...prev, [name]: validName }));
    }
    else {
      setorgform(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleChangedept = (e) => {
    const { name, value } = e.target;

    if (name === 'name') {
      const validName = value.replace(/[^a-zA-Z0-9 .\-&()]/g, '');
      setdeptform(prev => ({ ...prev, [name]: validName }));
    } else if (
      name === 'semester_fee' ||
      name === 'provisional_fee' ||
      name === 'intech_capacity'
    ) {
      const validNumber = value.replace(/\D/g, '');
      setdeptform(prev => ({ ...prev, [name]: validNumber }));

    } else {
      setdeptform(prev => ({ ...prev, [name]: value }));
    }
  };
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!isRequired(orgform.organization_id)) return displayToast('Institution is required', 'danger');
    if (!isRequired(orgform.name)) return displayToast('Course Name is required', 'danger');
    if (!isRequired(orgform.level)) return displayToast('Level is Required', 'danger');
    if (!isRequired(orgform.mode)) return displayToast('Mode is required', 'danger');
    if (!isRequired(orgform.mode_count)) return displayToast('Mode count is required', 'danger');
    if (!isRequired(orgform.duration)) return displayToast('Duration is required', 'danger');
    if (!isRequired(orgform.alias)) return displayToast('Alias is required', 'danger');
    // ✅ Subjects validation
    // ✅ Subjects validation
    if (!Array.isArray(orgform.subjects) || orgform.subjects.length === 0) {
      return displayToast("At least one subject is required", "danger");
    }

    const invalidSubject = orgform.subjects.some(
      (sub) =>
        !sub.name ||
        !sub.semester ||
        !sub.type
    );

    if (invalidSubject) {
      return displayToast(
        "Subject Name, Semester and Type are required for all subjects",
        "danger"
      );
    }


    const finalobj = {
      name: orgform.name,
      level: orgform.level,
      mode: orgform.mode,
      mode_count: parseInt(orgform.mode_count),
      duration: orgform.duration,
      organization_id: parseInt(orgform.organization_id),
      alias: orgform.alias,
      // Backend expects a comma-separated string of subject names. The
      // Subjects model only stores `name`; semester/type collected by the
      // form are not persisted server-side.
      course_subjects_str: orgform.subjects
        .map(subjectName)
        .filter(Boolean)
        .join(','),

    }
    setIsSubmitting(true); // ✅ START SPINNER


    try {
      const url = 'academics/courses/';
      const response = await PostdataWithJson(url, finalobj);

      if (response && !response.error) {
        displayToast('Course Added successfully!', 'success');
        setRefreshKey(prev => prev + 1)
        closeModal();
      } else if (response && response.error) {
        const errorMsg = response.error?.[0] || 'Error Adding Course.';
        displayToast(errorMsg, 'danger');
      } else {
        displayToast('Unexpected error occurred.', 'danger');
      }
    } catch {
      displayToast('Unexpected error occurred.', 'danger');
    } finally {
      setIsSubmitting(false); // ✅ STOP SPINNER
    }
  }

  const handleSubmitdept = async () => {

    if (!isRequired(deptform.name)) return displayToast('Specialization Name is required', 'danger');
    if (!isRequired(deptform.course_code)) return displayToast('Course is Required', 'danger');
    // if (!isRequired(deptform.semester_fee)) return displayToast('SemhandleSubmit,ester fee is required', 'danger');
    // if (!isRequired(deptform.provisional_fee)) return displayToast('Provisional Fee is required', 'danger');
    if (!isRequired(deptform.intech_capacity)) return displayToast('Intech Capacity is required', 'danger');

    // Note: subjects validation was removed here — it inspected the parent
    // course form's `orgform.subjects`, which has nothing to do with the
    // specialization payload below and crashed when subjects were objects
    // instead of strings.

    const finalobj = {
      id: deptform.id,
      name: deptform.name,
      course_code: deptform.course_code,
      semester_fee: deptform.semester_fee,
      provisional_fee: deptform.provisional_fee,
      intech_capacity: parseInt(deptform.intech_capacity)
    }
    const url = `academics/courses/${parentorgid ? parentorgid : finalobj.id}/specializations/`;
    const response = await PostdataWithJson(url, finalobj);
    if (response && !response.error) {
      displayToast('Specialization Added successfully!', 'success');
      // getdeptdata(parentorgid);
      setSelectedOrgDetails(prev => ({ ...prev }));
      setRefreshKey(prev => prev + 1)
      closeModaldept();
    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error Adding Specialization.';
      displayToast(errorMsg, 'danger');
    } else {

      displayToast('Unexpected error occurred.', 'danger');
    }

  }



  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setUpdatebtn(false);
    handleClear();

  };
  const openModaldept = () => {
    setIsModalOpendept(true);
  };
  const closeModaldept = () => {
    setIsModalOpendept(false);
    handleCleardept();
    setUpdatebtn(false);
  };

  const handleRowClick = (orgId, row) => {
    const selectedOrg = row?.original;
    if (!selectedOrg?.id) return;
    const { id, name, parent, email } = selectedOrg;
    setSelectedOrgDetails(selectedOrg);
    setparentorgid(id);
    setdeptform({ id });
  };


  const handleEdit = (row) => {
    const orgData = row.original;
    console.log("orgdata", orgData)
    setorgform({
      id: orgData.id,
      name: orgData.name,
      level: orgData.level,
      mode: orgData.mode,
      mode_count: orgData.mode_count,
      duration: orgData.duration,
      organization_id: orgData.organization_id,
      alias: orgData.alias,
      // status:false
      // ✅ FIX HERE
      subjects: orgData.course_subjects
        ? orgData.course_subjects.split(',').map(s => s.trim())
        : [''],

    });
    setparentorgidsub(orgData.id);
    openModal();
    setUpdatebtn(true);

  };
  const handleEditdept = (row) => {
    setdeptform(
      {
        id: row.id,
        name: row.name,
        course_code: row.course_code,
        semester_fee: row.semester_fee,
        provisional_fee: row.provisional_fee,
        intech_capacity: parseInt(row.intech_capacity)
      }
    )
    setUpdatebtn(true);
    openModaldept();
  }
  const handleupdatedept = async () => {
    if (!isRequired(deptform.name)) return displayToast('Specialization Name is required', 'danger');
    if (!isRequired(deptform.course_code)) return displayToast('Course is Required', 'danger');
    if (!isRequired(deptform.semester_fee)) return displayToast('Semester fee is required', 'danger');
    if (!isRequired(deptform.provisional_fee)) return displayToast('Provisional Fee is required', 'danger');
    if (!isRequired(deptform.intech_capacity)) return displayToast('Intech Capacity is required', 'danger');


    const finalobj = {
      id: deptform.id,
      name: deptform.name,
      course_code: deptform.course_code,
      semester_fee: deptform.semester_fee,
      provisional_fee: deptform.provisional_fee,
      intech_capacity: parseInt(deptform.intech_capacity)
    }
    const url = `academics/courses/${parentorgid}/specializations/${finalobj.id}/`

    const response = await updateData(url, finalobj);
    if (response && !response.error) {
      displayToast('Specialization Added successfully!', 'success');
      // getdeptdata(parentorgid)
      setSelectedOrgDetails(prev => ({ ...prev }));
      setRefreshKey(prev => prev + 1)
      closeModaldept()

    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error Adding Specialization.';
      displayToast(errorMsg, 'danger');
    } else {
      displayToast('Unexpected error occurred.', 'danger');
    }
  }

  const handleUpdate = async () => {
    if (!isRequired(orgform.name)) return displayToast('Course Name is required', 'danger');
    if (!isRequired(orgform.level) || !isRequired(orgform.level)) return displayToast('Level is Required', 'danger');
    if (!isRequired(orgform.mode) || !isRequired(orgform.mode)) return displayToast('Mode is required', 'danger');
    if (!isRequired(orgform.mode_count)) return displayToast('Mode count is required', 'danger');
    if (!isRequired(orgform.duration)) return displayToast('Duration is required', 'danger');
    if (!isRequired(orgform.organization_id)) return displayToast('Organization is required', 'danger');
    if (!isRequired(orgform.alias)) return displayToast('Alias is required', 'danger');


    // ✅ Subjects validation
    if (!Array.isArray(orgform.subjects) || orgform.subjects.length === 0) {
      return displayToast('At least one subject is required', 'danger');
    }

    // Trim & normalize (case-insensitive). subjects may be strings (from
    // handleEdit) or {name,...} objects (from addSubjectRow); subjectName
    // handles both.
    const normalizedSubjects = orgform.subjects.map(sub =>
      subjectName(sub).toLowerCase()
    );

    // Empty check
    if (normalizedSubjects.some(name => !name)) {
      return displayToast('All subject fields are required', 'danger');
    }

    // ✅ Duplicate check
    const uniqueSubjects = new Set(normalizedSubjects);

    if (uniqueSubjects.size !== normalizedSubjects.length) {
      return displayToast('Duplicate subject names are not allowed', 'danger');
    }




    const finalobj = {
      id: orgform.id,
      name: orgform.name,
      level: orgform.level,
      mode: orgform.mode,
      mode_count: orgform.mode_count,
      duration: orgform.duration,
      organization_id: orgform.organization_id,
      alias: orgform.alias,
      course_subjects_str: orgform.subjects
        .map(subjectName)
        .filter(Boolean)
        .join(','),

    }
    setIsSubmitting(true); // ✅ START SPINNER

    try {

      const url = `academics/courses/${finalobj.id}/`
      const response = await updateData(url, finalobj);
      console.log("error in update", response)
      if (response && !response.error) {
        displayToast('Course Updated successfully!', 'success');
        // Pass current page and updated row id to getorgdata
        setRefreshKey(prev => prev + 1)
        // getorgdata(classPage, selectedOrgDetails.id);
        setUpdatebtn(false);
        closeModal();
      } else if (response?.error) {
        let errorMsg = 'Error Updating Course.';

        if (Array.isArray(response.error)) {
          errorMsg = response.error[0];
        } else if (typeof response.error === 'object') {
          const firstKey = Object.keys(response.error)[0];
          errorMsg = response.error[firstKey]?.[0];
        }

        displayToast(errorMsg, 'danger');
      }

    } catch {
      displayToast('Unexpected error occurred.', 'danger');
    } finally {
      setIsSubmitting(false); // ✅ STOP SPINNER
    }

  }






  const sourceData = useMemo(() => {

    return filterQueryString
      ? filteredCourseData
      : classData;
  }, [classData, filteredCourseData, filterQueryString]);

  const formattedData = useMemo(() => {
    return sourceData.map((org) => ({
      id: org.id,
      name: org.name,
      level: org.level,
      mode: org.mode,
      alias: org.alias,
      mode_count: org.mode_count,
      duration: org.duration,
      organization_id: org.organization_id,
      organization: org.organization,
      status: org.status,
      course_subjects: org.course_subjects,
      handleRowClick: handleRowClick


    }));
  }, [sourceData]);


  const handleClear = () => {
    setorgform(
      {
        orgname: '',
        parentorgidog: null,
        gstin: '',
        email: '',
        landlineno: '',
        mobileno: '',
        address: '',
        pincode: '',
        countrycode: '1'
      }
    )
    setparentorgidsub(null);


  }
  const handleCleardept = () => {
    setdeptform({
      name: "",
      parent_department_id: null,
      country_code: "",
      area_code: '',
      landline: "",
      mobile: "",
      email: ""
    })
    setUpdatebtn(false);
  }
  const handleStatus = async (row) => {
    const newStatus = !row.original.status;

    row.original.status = newStatus;
    const url = `academics/courses/${row.original.id}/`;
    const response = await patchData(url, { status: newStatus });

    if (response && !response.error) {
      displayToast('Status Updated successfully!', 'success');
      // getorgdata()
      skipSpinnerRef.current = true;
      setRefreshKey(prev => prev + 1);
    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error Updating Status.';
      displayToast(errorMsg, 'danger');
    } else {
      displayToast('Unexpected error occurred.', 'danger');
    }

  };




  const handleStatusDept = async (department) => {
    const newStatus = !department.status;

    // Update the status locally
    const updatedDepartmentDetails = departmentdetails?.map(dept => {
      if (dept.id === department.id) {
        return { ...dept, status: newStatus };
      }
      return dept;
    });


    setdepartmentdetails(updatedDepartmentDetails);
    const url = `academics/courses/${parentorgid}/specializations/${department.id}/`;
    const response = await patchData(url, { status: newStatus });

    if (response && !response.error) {
      displayToast('Status Updated successfully!', 'success');
      setRefreshKey(prev => prev + 1)
    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error Updating Status.';
      displayToast(errorMsg, 'danger');
    } else {
      displayToast('Unexpected error occurred.', 'danger');
    }
  };

  const columns = useMemo(
    () => [
      // {
      //   Header: <input type='checkbox' />,
      //   accessor: 'checkbox',
      //   Cell: ({ row }) => (
      //     <input type="checkbox" checked={row.isSelected} onChange={() => row.toggleRowSelected()}
      //       style={{ cursor: 'pointer' }} />
      //   ),
      // },
      {
        Header: 'Course Name',
        disableSortBy: true,
        accessor: 'name',
        Cell: ({ row }) => (
          <div style={{ cursor: 'pointer', height: "100%", display: 'flex', alignItems: 'center' }} onClick={() => { handleRowClick(row.original.id, row) }}>
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.name}</p>
          </div>
        )
      },
      {
        Header: 'Alias',
        disableSortBy: true,
        accessor: 'alias',
        Cell: ({ row }) => (
          <div style={{ cursor: 'pointer', height: "100%", display: 'flex', alignItems: 'center' }}>

            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.alias}</p>
          </div>
        )
      },

      {
        Header: 'Level',
        disableSortBy: true,
        accessor: 'level',
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.level}</p>
          </div>
        )
      },
      {
        Header: 'Mode',
        accessor: 'mode',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.mode}</p>
          </div>
        )
      },
      {
        Header: 'Semester Count',
        accessor: 'modecount',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.mode_count}</p>
          </div>
        )
      },
      {
        Header: 'Duration( in month)',
        accessor: 'duration',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.duration}</p>
          </div>
        )
      },
      {
        Header: 'Institution Name',
        disableSortBy: true,
        accessor: 'organization',
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.organization}</p>
          </div>
        )
      },
      {
        Header: 'Action',
        disableSortBy: true,
        Cell: ({ row }) => (<>
          <div style={{ display: 'flex', gap: '10px' }}>
            <div class="form-check form-switch custom-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" style={{ cursor: 'pointer' }} checked={row.original.status} onChange={() => handleStatus(row)} />
            </div>
            <img src={edit} style={{ cursor: 'pointer' }} onClick={() => handleEdit(row)}></img>
          </div>
        </>
        ),
      },

    ],
    []
  );


  useEffect(() => {
    getorgdata();
    // getdeptdata();
    getmasterdata();
    getorgdata2();

  }, [])


  const searchInputRef = useRef(null);

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  const handleSetSearchResults = (data) => {
    const results = Array.isArray(data)
      ? data
      : Array.isArray(data?.items)
        ? data.items
        : [];

    setFilteredCourseData(results);

    if (results.length > 0) {
      setSelectedOrgDetails(results[0]);
      getdeptdata(results[0].id);
    } else {
      setSelectedOrgDetails(null);
    }
  };

  const handleSearchValueChange = (value) => {
    setSearchValue(value);

    if (!value.trim()) {
      setFilterQueryString((prev) => {
        if (!prev || typeof prev !== 'object') return {};
        const { search, ...rest } = prev;
        return rest;
      });
      // setIsSearchMode(false);
      setIsSearching(false);
      setClassPage(0);
    } else {
      // Add search key to existing filter
      setFilterQueryString((prev) => ({
        ...(prev || {}),
        search: value.trim(),
      }));
      // setIsSearchMode(true);
      setIsSearching(true);
      setClassPage(0);
    }
  }


  return (
    <>    {isLoading ? (
      <TableSkeleton rows={10} columns={6} showHeader={true} />
    ) :
      (
        <div style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
          position: "relative",
        }}>

          {/* ✅ FIXED: Add Button */}
          <div style={{ flexShrink: 0, padding: "0 12px" }}>
            <div className='row'>
              <div className="col-md-12 d-flex justify-content-end">
                <button className='add-btn' onClick={() => openModal()}>
                  <span className='me-2'>
                    <svg width="12" height="12" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.4286 13.3537H12.5714V21.2108C12.5714 21.6276 12.4059 22.0273 12.1112 22.322C11.8165 22.6167 11.4168 22.7822 11 22.7822C10.5832 22.7822 10.1835 22.6167 9.88883 22.322C9.59413 22.0273 9.42857 21.6276 9.42857 21.2108V13.3537H1.57143C1.15466 13.3537 0.754961 13.1881 0.460261 12.8934C0.165561 12.5987 0 12.199 0 11.7822C0 11.3655 0.165561 10.9658 0.460261 10.6711C0.754961 10.3764 1.15466 10.2108 1.57143 10.2108H9.42857V2.35366C9.42857 1.93689 9.59413 1.53719 9.88883 1.24249C10.1835 0.947787 10.5832 0.782227 11 0.782227C11.4168 0.782227 11.8165 0.947787 12.1112 1.24249C12.4059 1.53719 12.5714 1.93689 12.5714 2.35366V10.2108H20.4286C20.8453 10.2108 21.245 10.3764 21.5397 10.6711C21.8344 10.9658 22 11.3655 22 11.7822C22 12.199 21.8344 12.5987 21.5397 12.8934C21.245 13.1881 20.8453 13.3537 20.4286 13.3537Z" fill="white" />
                    </svg>
                  </span>
                  Add New Course
                </button>
              </div>
            </div>
          </div>

          {/* ✅ FIXED: Title + Search */}
          <div style={{ flexShrink: 0, padding: "8px 12px" }}>
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-md-7">
                <h2 className='main-heading'>Courses ({totalCount})</h2>
              </div>
              <div className="col-md-5">
                <div style={{ display: "flex", justifyContent: 'end' }}>
                  <SearchingBar
                    placeholder="Search by Course name, Alias"
                    url="academics/courses/"
                    filterQueryString={filterQueryString}
                    setResults={handleSetSearchResults}
                    ref={searchInputRef}
                    setTotalCount={setTotalCount}
                    setFilterQueryString={setFilterQueryString}
                    setIsLoading={setIsLoading}
                    setSearchLoading={setSearchLoading}
                    setCurrentPage={setClassPage}
                    setIsSearching={setIsSearching}
                    onTransitionChange={setIsSearchPending}
                    setSearchValue={handleSearchValueChange}
                    searchValue={searchValue}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ✅ SCROLLABLE BODY: Table (left) + Side Panel (right) */}
          <div style={{
            display: "flex",
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
            padding: "0 12px",
          }}>

            {/* LEFT: Table — only tbody scrolls */}
            <div style={{
              flex: "0 0 75%",
              maxWidth: "75%",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              overflow: "hidden",
              paddingRight: "12px",
            }}>
              {showSpinner ? (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh'
                }}>
                  <SpinnerLoader />
                </div>
              ) : formattedData && formattedData?.length > 0 ? (
                <>
                  <AdvanceTable
                    columns={columns}
                    pageCounts={pageCounts}
                    handlePageChange={handleClassPageChange}
                    selectedData={selectedOrgDetails}
                    data={formattedData}
                    handleRowClick={handleRowClick}
                    currentPage={classPage}
                    checkbox={false}
                  />
                  <TableLoaderOverlay isLoading={tableLoading} />
                </>
              ) : (!isLoading && !isSearchLoading && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh',
                  color: '#888',
                  textAlign: 'center',
                }}>
                  No Data found.
                </div>
              ))}
            </div>

            {/* RIGHT: Side Panel */}
            <div  className="shortdetails" style={{
              flex: "0 0 25%",
              maxWidth: "25%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}>
              <CourseShortDetails
                navigate={navigate}
                closeModaldept={closeModaldept}
                isModalOpendept={isModalOpendept}
                openModaldept={openModaldept}
                selectedOrgDetails={selectedOrgDetails}
                departmentdetails={departmentdetails}
                deptform={deptform}
                handleChangedept={handleChangedept}
                handleSubmitdept={handleSubmitdept}
                handleEditdept={handleEditdept}
                Updatebtn={Updatebtn}
                handleupdatedept={handleupdatedept}
                handleCleardept={handleCleardept}
                handleStatusDept={handleStatusDept}
                courseName={selectedOrgDetails?.name}
              />
            </div>
          </div>

        </div>

      )}

      <div>
        <AddCourse isOpen={isModalOpen} onClose={closeModal} setsubmit={setsubmit} dnparentdata={dnparentdata} handleChange={handleChange} orgform={orgform} handleSubmit={handleSubmit} openModaldept={openModaldept} closeModaldept={closeModaldept}
          Updatebtn={Updatebtn} handleUpdate={handleUpdate} setparentorgidsub={setparentorgidsub} parentorgidsub={parentorgidsub} masterdata={masterdata} handleSubjectChange={handleSubjectChange} addSubjectRow={addSubjectRow} removeSubjectRow={removeSubjectRow} isSubmitting={isSubmitting} setIsSubmitting={setIsSubmitting}
          dnparentdata2={dnparentdata2} setRefreshKey={setRefreshKey} duplicateSubjects={duplicateSubjects} />
      </div>
      {showToast && (
        <div
          className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
          role="alert"
          style={{
            display: 'block',
            minWidth: '300px',
            maxWidth: '400px',
            borderRadius: '8px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            fontSize: '15px',
            zIndex: 9999
          }}
        >
          <div className="d-flex">
            <div className="toast-body" style={{ padding: '12px 16px' }}>
              <strong>{toastVariant === 'success' ? '✅' : '❌'} </strong> {toastMessage}
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
              aria-label="Close"
            ></button>
          </div>
        </div>

      )}

    </>
  );
};


